module.exports = __webpack_public_path__ + "img/main-3_m.dc490423.jpg";